<template>
  <div class="container">
    <el-form :inline="true">
        <el-form-item :required="true" label="活动类型">
        <el-select
          v-model="type"
          placeholder="请选择"
        >
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
        <el-button type="success" @click="openAdd">新增</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #type="{ row }">
        {{ getNameByValue(typeList, row.type) }}
      </template>
      <template #handler="{ row }">
        <div>
          <el-button type="primary" size="small" @click="openEdit(row)"
            >修改</el-button
          >
          <el-button type="success" size="small" @click="getQrCode(row)"
            >二维码</el-button
          >
          <el-button type="primary" size="small" @click="toJoinRecord(row)"
            >报名情况</el-button
          >
        </div>
      </template>
    </auto-table>

    <!-- 二维码 -->
    <el-dialog title="二维码" :visible.sync="qrdialogVisible" width="40%">
      <div class="flex jc-c">
        <img :src="codeimg" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qrdialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <AddorEdit ref="add" @success="getList(1)"></AddorEdit>
  </div>
</template>

<script>
import AddorEdit from "./components/activity/AddorEdit.vue";
import { typeList } from "./components/dict.js";

export default {
  components: {
    AddorEdit
  },
  data() {
    return {
      typeList,
      DataList: [],
      Option: [
        { name: "名称", value: "title" },
        { name: "城市", value: "city" },
        { name: "截至报名", value: "end_time" },
        { name: "类型", value: "type", type: "custom" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
      qrdialogVisible: false,
      codeimg: "",
      type: ''
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    toJoinRecord(row) {
      this.$router.push({ name: "salonjoinList", query: { id: row.id } });
    },
    getQrCode(row) {
      let page = "pages/index/salon/salon";
      let data = {
        scene: "id=" + row.id,
        page: page,
      };
      this.qrdialogVisible = true;
      this.$axios({
        url: "/user/coach/generateQRCodeSportPic",
        data,
        method: "post",
      }).then((res) => {
        this.codeimg = res.data.data.img;
      });
    },

    openAdd() {
      let comm = { venue_id: this.id };
      this.$refs.add.open(comm);
    },
    openEdit(row) {
      this.$refs.add.open(row);
    },

    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/salonActivity/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          type: this.type || null,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>